


























































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Footer extends Vue {
  public get year() {
    return new Date().getFullYear();
  }
}
